import React, { useCallback } from 'react';
import { Link } from 'react-router-dom';
import useEnlog from 'app/hook/common/useEnlog';

import classNames from 'classnames/bind';
import styles from './Button.module.scss';

const cx = classNames.bind(styles);

function Button(props) {
	const {
		type = '',
		domType = 'button',
		title,
		to = '',
		color = 'red',
		size = '50',
		inline = false,
		shadow = false,
		square = false,
		onClick = () => console.warn('onClick is not defined.'),
		style = null,
		classArray = [],
		disabled = false,
		titleBefore = null,
		titleAfter = null,
		uialignItemClass = [],
		loading = false,
		id = undefined,
		buttonRef = null,
	} = props;

	const { propsDataset } = useEnlog();

	const dataSet = propsDataset(props);

	let className = null;
	let dom = null;

	switch (type.toLowerCase()) {
		case 'arrow':
			className = 'uibtn_arr';
			break;
		default:
			className = [
				'uibtn',
				`uibtn_${color}`,
				`uibtn_size_h${size}`,
				{ uibtn_inline: inline },
				{ uibtn_shadow: shadow },
				{ uibtn_square: square },
				type && `uibtn_${type}`,
			];
	}
	const preventDoubleClick = useCallback(() => false, []);
	const text = (
		<>
			{loading && <span className={cx('loading')} />}
			{titleBefore} {title} {titleAfter}
		</>
	);

	switch (domType.toLowerCase()) {
		case 'submit':
		case 'button':
			dom = (
				<button
					type={domType.toLowerCase()}
					id={id}
					className={cx(className)}
					disabled={disabled}
					onClick={!loading ? onClick : () => console.warn('loading..')}
					onDoubleClick={preventDoubleClick}
					ref={buttonRef}
					{...dataSet}
				>
					{text}
				</button>
			);
			break;

		case 'link':
			dom = (
				<Link
					to={to}
					id={id}
					className={cx(className)}
					onClick={onClick}
					{...dataSet}
				>
					{text}
				</Link>
			);
			break;

		case 'anchor':
			dom = (
				<a
					href={to}
					id={id}
					className={cx(className)}
					onClick={onClick}
					{...dataSet}
				>
					{text}
				</a>
			);
			break;

		case 'blankanchor':
			dom = (
				<a
					href={to}
					id={id}
					className={cx(className)}
					target="_blank"
					rel="noopener noreferrer"
					onClick={onClick}
					{...dataSet}
				>
					{text}
				</a>
			);
			break;

		default:
			dom = null;
	}

	return (
		<div
			className={cx(uialignItemClass, classArray)}
			style={style}
		>
			{dom}
		</div>
	);
}

export default Button;
